import { render } from "./ms-powerpoint-icon.svg?vue&type=template&id=eb779a86"
import script from "./ms-powerpoint-icon.svg?vue&type=script&lang=js"
export * from "./ms-powerpoint-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3609/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__